import { Divider, Input, Select, Space } from "antd";
import TextArea from "antd/lib/input/TextArea";
import 'moment-timezone';
import React, { useState } from 'react';
import Loading from "../Loading";
import Toastr from 'toastr';
import CommonUtils from "../../util/CommonUtils";
import SessionManager from "../../routes/SessionManager";
import API from '../../service/SiteKickAPIService';

function TalkDownModal(props) {

    let sessionManager = new SessionManager();
    let user = sessionManager.readCookie('user');

    const [devices_selected, setDevicesSelected] = useState([]);
    const [message_to_speak, setMessageToSpeak] = useState("");
    const [message_repeat, setMessageRepeat] = useState(2);
    const [volume, setVolume] = useState(100);
    const [devices] = useState(props.devices || []);

    const publishTalkDown = () => {

        let _devices_selected = {};
        for (let d of devices_selected)
            _devices_selected[d.split('@')[0]] = 1;

        let data = {
            customer_id: user.customer_id,
            site_id: user.site_selected.site_id,
            user_login: user.user_login,
            user_token: user.user_token,
            devices: Object.keys(_devices_selected),
            message: {
                polly_voice_id: "Stephen",
                message_to_speak: message_to_speak,
                message_guid: new Date().getTime(),
                message_volume: parseInt(volume || 100),
                message_repeat: parseInt(message_repeat || 2),
            }
        };

        CommonUtils.ajax(
            {
                url: API.AXIS_CAMERA.TALK_DOWN,
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    Toastr.success("Talk down message played successfully !");
                    setDevicesSelected([]);
                    setMessageToSpeak('');
                } else {
                    Toastr.error("Error occurred ... Please try again !");
                }
            },
            (res) => {
                Toastr.error("Error occurred ... Please try again !");
            });
    }

    const isFormValid = () => {
        if (message_to_speak.trim().length === 0 || devices_selected.length === 0) {
            return false;
        } else {
            return true;
        }
    }

    return (
        <React.Fragment>
            <div className="modal-header py-2 bg-primary text-white">
                <span className="modal-title">{props.title}</span>
                <div>
                    <button type='button' className='fa fa-expand' onClick={props.resizeModal}></button>
                    <button type='button' className='far fa-lg fa-times-circle pull-right' data-dismiss='modal' onClick={props.closeModal}></button>
                </div>
            </div>
            <div className="modal-footer bg-light" style={{ height: "2rem" }}>
                <label className="text-primary" style={{ position: "absolute", left: "1rem" }}>Site: {user && user.site_selected && user.site_selected.site_name}</label>
            </div>
            {!devices ? <div className="p-5"><Loading>Loading ...</Loading></div> :
                devices.length === 0 ? <center className="p-5">No talk down devices found.</center> :
                    <>
                        <div className='p-3 align-left'>
                            <div className="row">
                                <div className="col-md-12">
                                    <table width="100%" style={{ textAlign: "left" }}>
                                        <tbody>
                                            <tr>
                                                <td>Zones:</td>
                                                <td>
                                                    <Select
                                                        mode="multiple"
                                                        value={devices_selected}
                                                        style={{ width: '200px', fontSize: '13px' }}
                                                        onChange={(v) => setDevicesSelected(v)}
                                                        options={devices}
                                                        dropdownMatchSelectWidth={false}
                                                        placeholder="Choose Zones"
                                                        dropdownRender={(menu) => (
                                                            <>
                                                                {menu}
                                                                <Divider style={{ margin: '8px 0' }} />
                                                                <Space style={{ padding: '0px 4px' }}>
                                                                    <button className="btn btn-sm btn-success" onClick={() => setDevicesSelected(devices.map(x => x.value))}>
                                                                        All Zones
                                                                    </button>
                                                                </Space>
                                                            </>
                                                        )}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Message:</td>
                                                <td>
                                                    <Select
                                                        allowClear
                                                        style={{ width: '200px', fontSize: '13px' }}
                                                        onChange={(v) => setMessageToSpeak(v ? v : '')}
                                                        options={[
                                                            { value: 'You are in a protected area and under video surveillance. Please remove yourself from the area or we will dispatch the police.', label: 'You are in a protected area and under video surveillance. Please remove yourself from the area or we will dispatch the police.' },
                                                            { value: 'Please remove your self from the premise. We have you on video surveillance and the police are on their way.', label: 'Please remove your self from the premise. We have you on video surveillance and the police are on their way.' }
                                                        ]}
                                                        dropdownMatchSelectWidth={false}
                                                        placeholder="Choose From Default"
                                                    />
                                                </td>
                                            </tr>
                                            {CommonUtils.hasPermission('SITESUPT-UI-TALK-DOWN-MSG') &&
                                                <tr>
                                                    <td></td>
                                                    <td className="pt-3">
                                                        Otherwise, compose message below.
                                                        <TextArea
                                                            value={message_to_speak}
                                                            showCount
                                                            maxLength={250}
                                                            style={{ height: 120, resize: 'none' }}
                                                            onChange={(e) => setMessageToSpeak(e.target.value)}
                                                            placeholder="Enter message"
                                                        />
                                                    </td>
                                                </tr>
                                            }
                                            <tr>
                                                <td>Repeat:</td>
                                                <td><Input value={message_repeat} onChange={(e) => setMessageRepeat((isNaN(e.target.value) || e.target.value < 0) ? 2 : (e.target.value > 10 ? 2 : e.target.value))} className="w-75" type="number"></Input></td>
                                            </tr>
                                            <tr>
                                                <td>Volume:</td>
                                                <td><Input value={volume} onChange={(e) => setVolume((isNaN(e.target.value) || e.target.value <= 0) ? 1 : (e.target.value > 100 ? 100 : e.target.value))} className="w-75" type="number"></Input></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer bg-light" style={{ height: "3rem" }}>
                            <button disabled={!isFormValid()} className="btn btn-xs btn-primary" onClick={() => publishTalkDown()}>Submit</button>
                        </div>
                    </>
            }
        </React.Fragment>
    );
}

export default TalkDownModal;